import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from './assets/logo-white.svg'
import _imports_1 from './assets/ar.svg'
import _imports_2 from './assets/video-58.svg'
import _imports_3 from './assets/video/painting.mp4'
import _imports_4 from './assets/video/salita.mp4'
import _imports_5 from './assets/video/funzionamento.mp4'


const _hoisted_1 = {
  class: "flex w-full justify-center items-center text-white",
  id: "app"
}
const _hoisted_2 = { class: "w-full max-w-xl h-full flex flex-col justify-between" }
const _hoisted_3 = { class: "p-4 w-full mt-8 h-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-64 mx-auto pt-2 mb-12",
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "flex flex-col flex-grow gap-4 justify-center items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-1/12"
}, null, -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-1/12 fill-white text-white"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("small", null, "Painting: infra-red drying", -1)
const _hoisted_12 = {
  ref: "painting",
  src: _imports_3,
  controls: "",
  muted: ""
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", null, "Carbody ascent on workstation", -1)
const _hoisted_15 = {
  ref: "salita",
  src: _imports_4,
  controls: "",
  muted: ""
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("small", null, "Train operation and testing", -1)
const _hoisted_18 = {
  ref: "funzionamento",
  src: _imports_5,
  controls: "",
  muted: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_swiper, {
          "allow-touch-move": false,
          "allow-slide-prev": false,
          onSwiper: _ctx.setSwiper,
          class: "h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_swiper_slide, { class: "flex flex-col h-full" }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: "btn",
                      key: link.key,
                      onClick: ($event: any) => (_ctx.showResults(link))
                    }, [
                      _createTextVNode(_toDisplayString(link.title), 1),
                      _hoisted_8,
                      _createElementVNode("small", null, _toDisplayString(link.eng), 1)
                    ], 8, _hoisted_7))
                  }), 128)),
                  _hoisted_9,
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalPainting = !_ctx.showModalPainting))
                  }, [
                    _createTextVNode("Painting: asciugatura a infrarossi"),
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _createVNode(_component_ModalDialog, {
                    show: _ctx.showModalPainting,
                    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalPainting = false))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("video", _hoisted_12, null, 512)
                    ]),
                    _: 1
                  }, 8, ["show"]),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalSalita = !_ctx.showModalSalita))
                  }, [
                    _createTextVNode("Salita della cassa in workstation"),
                    _hoisted_13,
                    _hoisted_14
                  ]),
                  _createVNode(_component_ModalDialog, {
                    show: _ctx.showModalSalita,
                    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalSalita = false))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("video", _hoisted_15, null, 512)
                    ]),
                    _: 1
                  }, 8, ["show"]),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModalFunzionamento = !_ctx.showModalFunzionamento))
                  }, [
                    _createTextVNode("Funzionamento e collaudo treno"),
                    _hoisted_16,
                    _hoisted_17
                  ]),
                  _createVNode(_component_ModalDialog, {
                    show: _ctx.showModalFunzionamento,
                    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModalFunzionamento = false))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("video", _hoisted_18, null, 512)
                    ]),
                    _: 1
                  }, 8, ["show"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onSwiper"])
      ])
    ])
  ]))
}